// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lVLzt","cover":"styles_cover__Fag2G","mainInfo":"styles_mainInfo__loXSC","playIcon":"styles_playIcon__1tC6C"};